import { render, staticRenderFns } from "./_base-overlay.vue?vue&type=template&id=84034a30&scoped=true&"
import script from "./_base-overlay.vue?vue&type=script&lang=js&"
export * from "./_base-overlay.vue?vue&type=script&lang=js&"
import style0 from "./_base-overlay.vue?vue&type=style&index=0&id=84034a30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84034a30",
  null
  
)

export default component.exports